<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-center justify-between px-6 pb-4 pt-6">
    <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.CHANGE_UNIT_MODAL.TITLE' | t }}</h2>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- aviso (ej. unidad base no disponible para la venta al agregar) reemplaza al bloque de producto -->
  @if (data.notice) {
  <div class="flex items-start gap-3 border-y border-amber-300 bg-amber-50 px-6 py-4 text-base text-amber-800 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200">
    <mat-icon class="icon-size-6 text-amber-600 dark:text-amber-300">warning</mat-icon>
    <span>{{ data.notice }}</span>
  </div>
  } @else {
  <!-- producto seleccionado -->
  <div class="bg-primary-50 px-6 py-3 dark:bg-primary-900/10">
    <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.CHANGE_UNIT_MODAL.SELECTED_PRODUCT' | t }}</span>
    <div class="text-primary font-bold">{{ data.item.code ? data.item.code + ' - ' + data.item.name : data.item.name }}</div>
  </div>
  }

  @if (dgConfig.isCompactScreen) {
  <!-- tarjetas de unidades -->
  <div class="min-h-0 flex-1 overflow-auto p-3">
    <div class="flex flex-col gap-3">
      @for (u of units; track u.unitMeasureId) {
      <div class="flex flex-col rounded-xl border bg-card p-3"
        [ngClass]="selectable(u) ? 'cursor-pointer' : 'opacity-50'"
        [class.border-primary]="isSelected(u)" [class.bg-primary-50]="isSelected(u)"
        [class.dark:bg-primary-900]="isSelected(u)" (click)="select(u)">
        <div class="flex items-start gap-2">
          <mat-checkbox class="-ml-2" [checked]="isSelected(u)" [disabled]="!selectable(u)"
            (change)="select(u)" (click)="$event.stopPropagation()"></mat-checkbox>
          <div class="flex min-w-0 flex-1 flex-col gap-1">
            <div class="flex flex-wrap items-center gap-2">
              <span class="font-semibold">{{ u.code }}</span>
              <span class="text-secondary">{{ u.name }}</span>
            </div>
            <div class="flex flex-wrap items-center gap-1">
              @if (u.chip === 'BASE') {
              <span class="rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-700 dark:bg-green-900/40 dark:text-green-300">BASE</span>
              } @else if (u.chip === 'SECUNDARIA') {
              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">SECUNDARIA</span>
              } @else if (u.chip === 'PARALELA') {
              <span class="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">PARALELA</span>
              }
              @if (!u.isCommercialUom) {
              <span class="rounded-full bg-gray-200 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-gray-700 dark:text-gray-300">{{ 'DOCUMENT_GENERATE.BADGES.NOT_SELLABLE' | t }}</span>
              }
              @if (u.isCommercialUom && !u.hasPrice && recalcMode !== 1) {
              <span class="rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">{{ 'DOCUMENT_GENERATE.BADGES.NO_PRICE' | t }}</span>
              }
            </div>
          </div>
        </div>
        <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
          <div class="col-span-2 flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.EQUIVALENCE' | t }}</span>
            <span class="text-right">{{ u.equivalence }}</span>
          </div>
          @if (data.showStock) {
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.AVAILABLE_STOCK' | t }}</span>
            <span class="font-semibold" [class.text-green-600]="u.stock > 0" [class.text-red-500]="u.stock <= 0">
              {{ u.stock | dgNumber:'stock' }}
            </span>
          </div>
          }
          <div class="flex items-center justify-between gap-2" [class.col-span-2]="!data.showStock">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.PRICE' | t }}</span>
            <span class="text-primary font-bold">{{ data.currency }}&nbsp;{{ u.price | dgNumber }}</span>
          </div>
        </div>
      </div>
      } @empty {
      <div class="text-secondary flex h-32 items-center justify-center px-4 text-center text-sm">
        {{ 'DOCUMENT_GENERATE.CHANGE_UNIT_MODAL.NO_ALTERNATE_UNITS' | t }}
      </div>
      }
    </div>
  </div>
  } @else {
  <!-- tabla de unidades -->
  <div class="min-h-0 flex-1 overflow-auto">
    <table class="w-full min-w-[620px] border-collapse text-base">
      <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
        <tr class="text-secondary text-left">
          <th class="px-4 py-3"></th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.CODE' | t }}</th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.NAME' | t }}</th>
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.FACTOR' | t }}</th>
          <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.EQUIVALENCE' | t }}</th>
          @if (data.showStock) {
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.AVAILABLE_STOCK' | t }}</th>
          }
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</th>
        </tr>
      </thead>
      <tbody>
        @for (u of units; track u.unitMeasureId) {
        <tr class="border-t"
          [ngClass]="selectable(u) ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/40' : 'opacity-50'"
          [class.bg-primary-50]="isSelected(u)" [class.dark:bg-primary-900]="isSelected(u)" (click)="select(u)">
          <td class="px-4 py-3">
            <mat-checkbox [checked]="isSelected(u)" [disabled]="!selectable(u)" (change)="select(u)"
              (click)="$event.stopPropagation()"></mat-checkbox>
          </td>
          <td class="px-4 py-3 font-medium">{{ u.code }}</td>
          <td class="px-4 py-3">
            <div class="flex items-center gap-2">
              <span>{{ u.name }}</span>
              @if (u.chip === 'BASE') {
              <span class="rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-700 dark:bg-green-900/40 dark:text-green-300">{{ 'DOCUMENT_GENERATE.BADGES.BASE' | t }}</span>
              } @else if (u.chip === 'SECUNDARIA') {
              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">{{ 'DOCUMENT_GENERATE.BADGES.SECONDARY' | t }}</span>
              } @else if (u.chip === 'PARALELA') {
              <span class="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">{{ 'DOCUMENT_GENERATE.BADGES.PARALLEL' | t }}</span>
              }
              @if (!u.isCommercialUom) {
              <span class="rounded-full bg-gray-200 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-gray-700 dark:text-gray-300">{{ 'DOCUMENT_GENERATE.BADGES.NOT_SELLABLE' | t }}</span>
              }
            </div>
          </td>
          <td class="px-4 py-3 text-right">{{ u.factor | number:'1.2-2' }}</td>
          <td class="text-secondary px-4 py-3">{{ u.equivalence }}</td>
          @if (data.showStock) {
          <td class="px-4 py-3 text-right font-semibold" [class.text-green-600]="u.stock > 0"
            [class.text-red-500]="u.stock <= 0">
            {{ u.stock | dgNumber:'stock' }}
          </td>
          }
          <td class="px-4 py-3 text-right font-semibold">
            @if (u.isCommercialUom && !u.hasPrice && recalcMode !== 1) {
            <span class="mb-1 block rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">{{ 'DOCUMENT_GENERATE.BADGES.NO_PRICE' | t }}</span>
            }
            {{ data.currency }}&nbsp;{{ u.price | dgNumber }}
          </td>
        </tr>
        } @empty {
        <tr>
          <td [attr.colspan]="data.showStock ? 7 : 6">
            <div class="text-secondary flex h-32 items-center justify-center text-sm">
              {{ 'DOCUMENT_GENERATE.MESSAGES.NO_ALTERNATE_UNITS' | t }}
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!selectedId" (click)="confirm()">
      {{ 'DOCUMENT_GENERATE.CHANGE_UNIT_MODAL.CONFIRM' | t }}
    </button>
  </div>
</div>
